module.exports = __webpack_public_path__ + "static/media/CircleChevronUp.884f4d33.svg";